var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { extractSupportProps } from '@snack-uikit/utils';
import { getRange } from '../../utils';
import { PageSliderButton } from '../PageSliderButton';
import styles from './styles.module.css';
const FIRST_PAGE = 1;
export function PaginationSlider(_a) {
    var { total, page, onChange, className } = _a, rest = __rest(_a, ["total", "page", "onChange", "className"]);
    return (_jsx("nav", Object.assign({ className: className }, extractSupportProps(rest), { children: _jsx("ul", { className: styles.paginationSlider, children: getRange(FIRST_PAGE, total).map(value => (_jsx("li", { children: _jsx(PageSliderButton, { activated: value === page, onClick: () => onChange(value), "data-test-id": `page-button-slider-${value}` }) }, value))) }) })));
}
